import './styles.scoped.css'
import {useEffect} from 'react'
import {Typography, Button, Modal, TextField} from '@mui/material'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {accountApi} from '../../../../services'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {parseError} from '../../../../utils/helpers'

export default ({open, setOpen, data, loadData}) => {
    const {setLoading, setMessageBox} = useGlobalStates()
    const form = useForm({
        resolver: yupResolver(
            yup.object().shape({
                reason: yup.string().required('Reason is required'),
            }),
        ),
    })

    useEffect(() => {
        form.reset()
    }, [open])

    const handleOk = reason => {
        setLoading(true)
        accountApi
            .deactivateUser(data?.id, reason)
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: 'Admin Deactivated',
                    description: 'This team member account has been deactivated. They no longer have access to the platform.',
                })
                loadData()
            })
            .catch(error => {
                setLoading(false)
                setOpen(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="title">
                        <Typography variant="h6" color="text.primary">
                            {`Deactivate ${data?.first_name}'s Account?`}
                        </Typography>
                    </div>
                    <br />
                    <Typography variant="body2" color="text.primary" style={{textAlign: 'center'}}>
                        Are you sure you want to deactivate this admin account? The team member will lose access to the platform until reactivated.
                        You can reactivate their account at any time.
                    </Typography>
                    <br />
                    <Typography variant="inputLabel" color="text.secondary">
                        Reason{' '}
                        <Typography variant="inputLabel" color="error">
                            *
                        </Typography>
                    </Typography>
                    <TextField
                        placeholder="Please tell us the reason..."
                        fullWidth
                        multiline
                        rows={5}
                        {...form.register('reason')}
                        error={!!form.formState.errors['reason']}
                        helperText={form.formState.errors['reason']?.message}
                    />
                    <br />
                    <br />
                    <div className="actions">
                        <Button variant="outlined" fullWidth onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                        <Button variant="contained" fullWidth color="error" onClick={form.handleSubmit(handleOk)}>
                            Deactivate Account
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
